import React, {Component} from 'react'

import HomeIcons from '../images/home_icon.svg'


const Jeyu = {
  h2: {
   fontSize: 25,
   color: '#014852',
   fontWeight: '500',
   textAlign: 'center'
  },
  features: {
   background: '#15decb',
   textAlign: 'center',
   color:'#014852',
   padding: '20px 0 0 0'
  },
  featuresBox: {
   display: 'inline-block',
   width: 150,
   height: 200,
   margin: '20px 40px',
  },
  featuresP: {
   color: '#014852'
  },
  icon1: {
   backgroundImage: 'url('+HomeIcons+')',
   backgroundSize: 'cover',
   backgroundRepeat: 'no-repeat',
   backgroundPosition: '5px 0px',
   width: 150,
   height: 141
  },
  icon2: {
   backgroundImage: 'url('+HomeIcons+')',
   backgroundSize: 'cover',
   backgroundRepeat: 'no-repeat',
   backgroundPosition: '-146px 0px',
   width: 150,
   height: 141
  },
  icon3: {
   backgroundImage: 'url('+HomeIcons+')',
   backgroundSize: 'cover',
   backgroundRepeat: 'no-repeat',
   backgroundPosition: '-295px 0px',
   width: 150,
   height: 141
  },
  icon4: {
   backgroundImage: 'url('+HomeIcons+')',
   backgroundSize: 'cover',
   backgroundRepeat: 'no-repeat',
   backgroundPosition: '-448px 0px',
   width: 150,
   height: 141
  },
  icon5: {
   backgroundImage: 'url('+HomeIcons+')',
   backgroundSize: 'cover',
   backgroundRepeat: 'no-repeat',
   backgroundPosition: '-597px 0px',
   width: 150,
   height: 141
  },
}

export default class Feature extends Component{
  render() {
    return(
      <div style={Jeyu.features}>
       <h2 style={Jeyu.h2}>JeyuTex除蟲布料特色</h2>
       <div style={Jeyu.featuresBox}>
        <div style={Jeyu.icon1}></div>
        <p style={Jeyu.featuresP}>有效消滅病媒蚊</p>
       </div>
       <div style={Jeyu.featuresBox}>
        <div style={Jeyu.icon2}></div>
        <p style={Jeyu.featuresP}>保證兩年功效</p>
       </div>
       <div style={Jeyu.featuresBox}>
        <div style={Jeyu.icon3}></div>
        <p style={Jeyu.featuresP}>國際檢驗認證</p>
       </div>
       <div style={Jeyu.featuresBox}>
        <div style={Jeyu.icon4}></div>
        <p style={Jeyu.featuresP}>全球獨家技術</p>
       </div>
       <div style={Jeyu.featuresBox}>
        <div style={Jeyu.icon5}></div>
        <p style={Jeyu.featuresP}>台灣製造品質保證</p>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Feature.js